import { render, staticRenderFns } from "./Staffmenu.vue?vue&type=template&id=21a1dae9&scoped=true&v-if=accessDetails"
import script from "./Staffmenu.vue?vue&type=script&lang=js"
export * from "./Staffmenu.vue?vue&type=script&lang=js"
import style0 from "./Staffmenu.vue?vue&type=style&index=0&id=21a1dae9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a1dae9",
  null
  
)

export default component.exports